import { Avatar, ListItem, Stack, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { ListItemBullet, VIconCircle } from 'Images';

interface ISecondeSegmentListItem {
  title: string;
  subtitle: string;
}

export const SecondeSegmentListItem = ({
  title,
  subtitle,
}: ISecondeSegmentListItem) => {
  const isDesktop = useIsDesktop();

  return (
    <ListItem
      sx={{
        flexDirection: 'column',
        padding: 0,
        alignItems: 'flex-start',
        rowGap: '10px',
      }}
      component='li'
    >
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='flex-start'
        gap='11px'
      >
        <Avatar
          src={VIconCircle}
          alt=''
          sx={{ width: '24px', height: '24px' }}
        />
        <Typography component='h1'>{title}</Typography>
      </Stack>
      <Typography ml='36px' variant='body3'>
        {subtitle}
      </Typography>
    </ListItem>
  );
};
